import React, { useRef, useContext } from "react";
import PropTypes from "prop-types";
import { connect } from "formik";
import cl from "classnames";
import RadiusInMiles from "./RadiusInMiles";
import LocationField from "./LocationField";
import classes from "../../styles/initialEventDetails.module.scss";
import muiClasses from "venuescanner-js/react/components/MuiFields/styles.module.scss";
import { ConfigContext } from "../../context";

const LOCATION_NAME = "location";
const RADIUS_NAME = "radiusInMiles";
const LocationAndRadius = connect(({ formik: { setFieldValue, values } }) => {
  const locationValue = values[LOCATION_NAME];
  const ref = useRef(null);
  const { base } = useContext(ConfigContext);

  const locationFieldBoxStyle = {
    width: locationValue ? "75%" : "100%",
  };

  const radiusInMilesBoxStyle = {
    display: locationValue ? "block" : "none",
  };

  return (
    <div className={cl(classes.FormField)}>
      <div id="locationFieldBox" style={locationFieldBoxStyle}>
        <div
          className={cl(
            muiClasses.MuiSelectFieldContainer,
            classes.LocationMuiSelectFieldContainer,
            {
              [muiClasses["MuiSelectFieldContainer--has-value"]]:
                !!locationValue,
            }
          )}
        >
          <label
            className={muiClasses.MuiSelectField__label}
            onClick={() => ref.current.focus()}
          >
            Where are you looking to hold your event?
          </label>
          <LocationField
            ref={ref}
            className={cl(muiClasses.SelectField, classes.noBottomBorder)}
            value={locationValue}
            filter={{ max_search_radius: 10 }}
            placeholder=""
            name={LOCATION_NAME}
            onChange={(val) => setFieldValue(LOCATION_NAME, val)}
            base={base}
            inputProps={{
              "data-ga": "location",
              "data-test-id": "venueSearch-locationField",
            }}
          />
        </div>
      </div>

      <div id="radiusInMilesBox" style={radiusInMilesBoxStyle}>
        <RadiusInMiles
          name={RADIUS_NAME}
          containerClassName={classes.RadiusInMilesMuiSelectFieldContainer}
          className={muiClasses.SelectField}
          placeholder=""
          inputProps={{ "data-ga": "radiusInMiles" }}
        />
      </div>
    </div>
  );
});

LocationAndRadius.propTypes = {
  formik: PropTypes.any,
};

export default LocationAndRadius;
